import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import classnames from 'classnames';
import Btns from './btns';
import { PureComponent } from '../component';
import Card from './Card';
import { transferClass } from './styles';
import Context from './context';
import splitSelecteds from './select';
import { isRTL } from '../config';
import getDataset from '../utils/dom/getDataset';
var DefaultProps = {
  titles: [],
  data: [],
  footers: [],
  operations: [],
  operationIcon: true,
  renderItem: function renderItem(d) {
    return d;
  },
  rowsInView: 20,
  lineHeight: 32,
  listHeight: 180
};

var Transfer =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Transfer, _PureComponent);

  var _super = _createSuper2(Transfer);

  function Transfer(props) {
    var _this;

    _classCallCheck(this, Transfer);

    _this = _super.call(this, props);
    _this.state = {
      selecteds: props.selectedKeys ? splitSelecteds(props.selectedKeys, props) : splitSelecteds(props.defaultSelectedKeys, props) || [[], []]
    };
    _this.getSelected = _this.getSelected.bind(_assertThisInitialized(_this));
    _this.setSelecteds = _this.setSelecteds.bind(_assertThisInitialized(_this));
    _this.getLoading = _this.getLoading.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Transfer, [{
    key: "getLoading",
    value: function getLoading(index) {
      var loading = this.props.loading;
      if (Array.isArray(loading)) return loading[index];
      return loading;
    }
  }, {
    key: "getSelected",
    value: function getSelected() {
      if ('selectedKeys' in this.props) return splitSelecteds(this.props.selectedKeys || [], this.props);
      return this.state.selecteds;
    }
  }, {
    key: "setSelecteds",
    value: function setSelecteds(index, value) {
      var onSelectChange = this.props.onSelectChange;
      var selecteds = this.state.selecteds;
      var newSelecteds = index ? [selecteds[0], value] : [value, selecteds[1]];
      if (onSelectChange) onSelectChange(newSelecteds[0], newSelecteds[1]);
      this.setState({
        selecteds: newSelecteds
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _this$props$titles = _this$props.titles,
          titles = _this$props$titles === void 0 ? DefaultProps.titles : _this$props$titles,
          data = _this$props.data,
          datum = _this$props.datum,
          keygen = _this$props.keygen,
          renderItem = _this$props.renderItem,
          _this$props$footers = _this$props.footers,
          footers = _this$props$footers === void 0 ? DefaultProps.footers : _this$props$footers,
          _this$props$operation = _this$props.operations,
          operations = _this$props$operation === void 0 ? DefaultProps.operations : _this$props$operation,
          operationIcon = _this$props.operationIcon,
          className = _this$props.className,
          style = _this$props.style,
          listClassName = _this$props.listClassName,
          listStyle = _this$props.listStyle,
          onFilter = _this$props.onFilter,
          onSearch = _this$props.onSearch,
          empty = _this$props.empty,
          disabled = _this$props.disabled,
          itemClass = _this$props.itemClass,
          _this$props$rowsInVie = _this$props.rowsInView,
          rowsInView = _this$props$rowsInVie === void 0 ? DefaultProps.rowsInView : _this$props$rowsInVie,
          _this$props$lineHeigh = _this$props.lineHeight,
          lineHeight = _this$props$lineHeigh === void 0 ? DefaultProps.lineHeight : _this$props$lineHeigh,
          _this$props$listHeigh = _this$props.listHeight,
          listHeight = _this$props$listHeigh === void 0 ? DefaultProps.listHeight : _this$props$listHeigh,
          renderFilter = _this$props.renderFilter,
          children = _this$props.children;
      var selecteds = this.getSelected();
      var datumValues = datum.getValue(); // use this.props.value prioritized

      if ('value' in this.props && datumValues !== this.props.value) {
        this.props.datum.setValue(this.props.value);
      }

      var sources = [];
      var targets = [];

      for (var i = 0; i < data.length; i++) {
        var d = data[i];

        if (datum.check(d)) {
          targets.push(d);
        } else {
          sources.push(d);
        }
      }

      return (
        /*#__PURE__*/
        React.createElement("div", Object.assign({
          className: classnames(transferClass('_', isRTL() && 'rtl'), className),
          style: style
        }, getDataset(this.props)),
        /*#__PURE__*/
        React.createElement(Context.Provider, {
          value: {
            selecteds: selecteds,
            setSelecteds: this.setSelecteds,
            itemClass: itemClass
          }
        },
        /*#__PURE__*/
        React.createElement(Card, {
          title: titles[0],
          selecteds: selecteds[0],
          data: sources,
          keygen: keygen,
          renderItem: renderItem,
          setSelecteds: this.setSelecteds,
          index: 0,
          footer: footers[0],
          listClassName: listClassName,
          listStyle: listStyle,
          loading: this.getLoading(0),
          onFilter: onFilter,
          empty: empty,
          disabled: disabled,
          onSearch: onSearch,
          rowsInView: rowsInView,
          lineHeight: lineHeight,
          listHeight: listHeight,
          renderFilter: renderFilter,
          customRender: children,
          values: datumValues
        }),
        /*#__PURE__*/
        React.createElement(Btns, {
          selecteds: selecteds,
          datum: datum,
          setSelecteds: this.setSelecteds,
          keygen: keygen,
          sources: sources,
          targets: targets,
          operations: operations,
          operationIcon: operationIcon,
          data: data,
          disabled: disabled
        }),
        /*#__PURE__*/
        React.createElement(Card, {
          title: titles[1],
          selecteds: selecteds[1],
          data: targets,
          keygen: keygen,
          renderItem: renderItem,
          loading: this.getLoading(1),
          setSelecteds: this.setSelecteds,
          index: 1,
          footer: footers[1],
          listClassName: listClassName,
          listStyle: listStyle,
          onFilter: onFilter,
          empty: empty,
          disabled: disabled,
          onSearch: onSearch,
          rowsInView: rowsInView,
          lineHeight: lineHeight,
          listHeight: listHeight,
          renderFilter: renderFilter,
          customRender: children,
          values: datumValues
        })))
      );
    }
  }]);

  return Transfer;
}(PureComponent);

Transfer.defaultProps = DefaultProps;
export default Transfer;